import { Injectable, Inject } from '@angular/core';
import { Utilities } from '@socrates/common';

@Injectable()
export class UrlPath {
	// the difference in these paths has to do with how the proxies are set up in webpack.dev.js for development,
	// and in nginx there is an analogous mechanism.
	// Root path is straight up talking to the originating web server.  We use proxies in order to bypass the need
	// to setup all the CORS overhead.

	private authUrl: string;
	private unauthUrl: string;
	private datastoreUrl: string;
	private imageServiceUrl: string;
	private orgStoreUrl: string;
	private rootUrl: string;

	constructor(@Inject('window') window: Window) {
		const protocol = window.location.protocol;
		const base = protocol && protocol.length > 0
			? protocol + '//' + window.location.host
			: window.location.host;

		this.rootUrl         = base + '/';
		this.authUrl         = base + '/api/auth/';
		this.unauthUrl       = base + '/api/unauth/';
		this.datastoreUrl    = base + '/api/ds/';
		this.imageServiceUrl = base + '/api/images/';
		this.orgStoreUrl     = base + '/api/users/';
	}

	getUnauthPath(path: string, tokens: any = null): string {
		return this.unauthUrl + Utilities.replaceTokens(path, tokens);
	}

	getAuthPath(path: string, tokens: any = null): string {
		return this.authUrl + Utilities.replaceTokens(path, tokens);
	}

	getDesignStorePath(path: string, tokens: any = null): string {
		return this.datastoreUrl + Utilities.replaceTokens(path, tokens);
	}

	getImageServicePath(path: string, tokens: any = null): string {
		return this.imageServiceUrl + Utilities.replaceTokens(path, tokens);
	}

	getOrgPath(path: string, tokens: any = null): string {
		return this.orgStoreUrl + Utilities.replaceTokens(path, tokens);
	}

	getRootPath(path: string, tokens: any = null): string {
		return this.rootUrl + Utilities.replaceTokens(path, tokens);
	}
}
